import Component from '../abstracts/Component';
import ProductPageLogic from '../businessLogic/ProductPageLogic';

export default class PdpEditorialComponent extends Component {

  get SELECTORS() {
    return {
      
    };
  }

  constructor() {
    super();
  }
  render() {
    this.ProductPageLogic = new ProductPageLogic(this);
    this.ProductPageLogic.render();
  }
}
